import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import './index2.js';
import { D as DomService } from './index3.js';
import { t as throttle } from './throttle.js';

const rocheTabNavContainerCss = "roche-tab-nav-container{display:block;display:flex;flex-wrap:nowrap;overflow-x:auto;gap:1.5rem;-ms-overflow-style:none;scrollbar-width:none;position:relative}roche-tab-nav-container::-webkit-scrollbar{display:none}@media (min-width: 48rem){roche-tab-nav-container{gap:1rem}}roche-tab-nav-container[blur-ends=both]{mask-image:linear-gradient(to right, transparent 0%, black 4rem), linear-gradient(to left, transparent 0%, black 4rem);mask-composite:intersect;-webkit-mask-image:linear-gradient(to right, transparent 0%, black 4rem), linear-gradient(to left, transparent 0%, black 4rem);-webkit-mask-composite:intersect}@supports selector(::-internal-media-controls-overlay-cast-button){roche-tab-nav-container[blur-ends=both]{-webkit-mask-composite:source-in}}roche-tab-nav-container[blur-ends=left]{mask-image:linear-gradient(to right, transparent 0%, black 4rem);-webkit-mask-image:linear-gradient(to right, transparent 0%, black 4rem)}roche-tab-nav-container[blur-ends=right]{mask-image:linear-gradient(to left, transparent 0%, black 4rem);-webkit-mask-image:linear-gradient(to left, transparent 0%, black 4rem)}";
const RocheTabNavContainerStyle0 = rocheTabNavContainerCss;

const RocheTabNavContainer$1 = /*@__PURE__*/ proxyCustomElement(class RocheTabNavContainer extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.handleTabHeaderScroll = (event) => {
            // only prevent scrolling when the end is not reached
            if (event.deltaY > 0 && (this.blurEnds === 'both' || this.blurEnds === 'right')) {
                event.preventDefault();
            }
            if (event.deltaY < 0 && (this.blurEnds === 'both' || this.blurEnds === 'left')) {
                event.preventDefault();
            }
            this.element.scrollLeft += (event.deltaY + event.deltaX);
        };
        this.blurEnds = undefined;
        this.setBlurStates = throttle(this.setBlurStates.bind(this), 80);
    }
    componentDidLoad() {
        this.refresh();
        this.element.addEventListener('wheel', this.handleTabHeaderScroll);
        this.element.addEventListener('scroll', this.setBlurStates);
        DomService.handleTextDirection(this.element);
        // observe changes to the active attribute
        this.observer = new MutationObserver(() => this.refresh());
        this.observer.observe(this.element, {
            childList: false,
            attributes: true,
            attributeFilter: ['active'],
            subtree: true,
        });
        // observe changes to the size
        const resizeObserver = new ResizeObserver(() => this.refresh());
        resizeObserver.observe(this.element);
    }
    refresh() {
        this.setBlurStates();
        this.scrollActiveItemIntoView();
    }
    scrollActiveItemIntoView() {
        const activeItem = this.element.querySelector('[active]');
        if (!activeItem)
            return;
        this.element.scrollLeft = (activeItem.offsetLeft + (activeItem.clientWidth / 2)) - (this.element.clientWidth / 2);
    }
    disconnectedCallback() {
        this.element.removeEventListener('wheel', this.handleTabHeaderScroll);
        this.element.removeEventListener('scroll', this.setBlurStates);
    }
    setBlurStates() {
        if (this.isLeftBlur() && this.isRightBlur()) {
            this.blurEnds = 'both';
        }
        else if (this.isLeftBlur()) {
            this.blurEnds = 'left';
        }
        else if (this.isRightBlur()) {
            this.blurEnds = 'right';
        }
        else {
            this.blurEnds = 'none';
        }
    }
    isLeftBlur() {
        // scrollLeft works differntly with rtl
        return DomService.isRtl(this.element)
            ? this.element.scrollLeft - 2 > this.element.clientWidth - this.element.scrollWidth
            : this.element.scrollLeft > 0;
    }
    isRightBlur() {
        // scrollLeft works differntly with rtl
        return DomService.isRtl(this.element) ? this.element.scrollLeft < 0
            : this.element.scrollLeft + 2 < this.element.scrollWidth - this.element.clientWidth;
    }
    render() {
        return (h("slot", { key: 'bdb6cbbdd34e823ceec49af66f1d98fd779b31ce' }));
    }
    get element() { return this; }
    static get style() { return RocheTabNavContainerStyle0; }
}, [4, "roche-tab-nav-container", {
        "blurEnds": [1537, "blur-ends"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-tab-nav-container"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-tab-nav-container":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheTabNavContainer$1);
            }
            break;
    } });
}

const RocheTabNavContainer = RocheTabNavContainer$1;
const defineCustomElement = defineCustomElement$1;

export { RocheTabNavContainer, defineCustomElement };

//# sourceMappingURL=roche-tab-nav-container.js.map